import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { toast } from "sonner";

interface DeleteOptions {
    onSettled?: () => void;
}

export const useDeleteBookingV4 = () => {
    const queryClient = useQueryClient();

    // PERBAIKAN: Terima opsi di dalam fungsi mutasi
    return useMutation<any, Error, { bookingId: string, options?: DeleteOptions }>({
        mutationFn: async ({ bookingId }) => {
            return await privateApi.delete(`/v4/booking/${bookingId}`);
        },
        onSuccess: () => {
            toast.success("Reservation deleted successfully", {
                id: 'delete-reservation'
            });
            // Invalidate query 'bookings' untuk memicu refetch dan memperbarui tabel
            queryClient.invalidateQueries({ queryKey: ['bookings'] });
            // List reservasi aktif (useGetAllBookingV4) pakai key 'bookings-v4', bukan 'bookings'
            // saja — tanpa ini tabel /admin/reservation tidak auto-refresh setelah delete.
            queryClient.invalidateQueries({ queryKey: ['bookings-v4'] });
        },
        onError: (error) => {
            toast.error((error as any)?.response?.data?.message || "Failed to delete reservation", {
                id: 'delete-reservation'
            });
        },
        onSettled: (_data, _error, variables) => {
            variables.options?.onSettled?.();
        },
    });
};